module.exports = __webpack_public_path__ + "img/yanfa.2a3a16b9.png";